import SingleLineText, { type SingleLineTextWidgetProps } from './single-line-text/index.js';

function ParagraphTextWidget(props: SingleLineTextWidgetProps) {
  return <SingleLineText multiline {...props} />;
}

export default ParagraphTextWidget;
